import { Fragment, useState } from "react";
import { Button, Typography } from "@mui/material";

export function TruncatedDescription({ text, maxLength = 50 }) {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isLong = text.length > maxLength;
  const displayText = expanded ? text : text.slice(0, maxLength);

  return (
    <Fragment>
      <Typography
        sx={{
          width: "100%",
          lineHeight: "1.3",
          color: "other.color1",
          transition: "all 350ms ease",
          wordBreak: "break-word",
          overflowWrap: "break-word",
          whiteSpace: "pre-wrap",
          display: "inline",
        }}
      >
        {displayText}
        {!expanded && isLong && "..."}
      </Typography>

      {isLong && (
        <Button
          variant="text"
          size="small"
          sx={{ ml: 1, textTransform: "none", p: 0, minWidth: "auto" }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "View Less" : "View More"}
        </Button>
      )}
    </Fragment>
  );
}
